// Where each paradigm of the book is printed in the archive.org scan of El-Dahdah's معجم تصريف الأفعال العربية
// (مكتبة لبنان, 1995 reprint): https://archive.org/details/hm4501. One row per book verb of test/fixtures/book:
// [root (normalised, hamza ء), wazn, classification ("" for quadriliterals), scan leaf, the verb as printed].
//
// The leaf is the viewer's 0-based image index (…/page/n<leaf>), read off the page headers by hand: the
// scan's own page-number metadata is wrong, and the printed numbers are leaf - 1 up to leaf 210 and leaf + 1
// from leaf 211 on (printed pp. 210-211, ظَلَّ جَفَّ هَدَّ, are missing from the scan, so those three verbs are
// not listed and fall back to the other 151 page).
export const BOOK_SCAN_URL = "https://archive.org/details/hm4501";

export const BOOK_SCAN: readonly (readonly [string, string, string, number, string])[] = [
  ["فعل", "فعَل يفعُل", "صحيح سالم", 126, "فَعَلَ"],
  ["رءف", "فعُل يفعُل", "صحيح مهموز العين", 199, "رَؤُفَ"],
  ["ضءل", "فعُل يفعُل", "صحيح مهموز العين", 199, "ضَؤُلَ"],
  ["ءخذ", "فاعل", "صحيح مهموز الفاء", 261, "آخَذَ"],
  ["دعم", "افتعل", "صحيح سالم", 335, "اِدَّعَمَ"],
  ["هنء", "فعَل يفعُل", "صحيح مهموز اللام", 136, "هَنَأَ"],
  ["دعو", "فعَل يفعُل", "معتل ناقص واوي", 142, "دَعا"],
  ["هيء", "فعُل يفعُل", "معتل أجوف يائي مهموز اللام", 204, "هَيُؤَ"],
  ["وفي", "فعَل يفعِل", "معتل لفيف مفروق", 165, "وَفَى"],
  ["ولي", "فعِل يفعِل", "معتل لفيف مفروق", 239, "وَلِيَ"],
  ["فعل", "تفاعل", "صحيح سالم", 303, "تَفاعَلَ"],
  ["فرر", "فعَل يفعِل", "صحيح مُضعَّف", 148, "فَرَّ"],
  ["خوف", "فعِل يفعَل", "معتل أجوف واوي", 223, "خافَ"],
  ["فعلل", "فعلل", "", 386, "فَعْلَلَ"],
  ["سمع", "تفعّل", "صحيح سالم", 288, "اِسَّمَّعَ"],
  ["فعل", "فعّل", "صحيح سالم", 242, "فَعَّلَ"],
  ["حيي", "فعِل يفعَل", "معتل لفيف مقرون مُضعَّف يائي", 230, "حَيِيَ"],
  ["حوصل", "افعنلل", "", 413, "اِحْوَنْصَلَ"],
  ["رعو", "افعلّ", "معتل ناقص واوي", 358, "اِرْعَوَى"],
  ["فوعل", "تفعلل", "", 399, "تَفَوْعَلَ"],
  ["ظنن", "افتعل", "صحيح مُضعَّف", 337, "اِظَّنَّ"],
  ["صعد", "تفاعل", "صحيح سالم", 305, "اِصّاعَدَ"],
  ["فعل", "فاعل", "صحيح سالم", 257, "فاعَلَ"],
  ["بقي", "فعِل يفعَل", "معتل ناقص يائي", 226, "بَقِيَ"],
  ["ورب", "انفعل", "معتل مثال واوي", 326, "اِنْوَرَبَ"],
  ["مدد", "فعَل يفعُل", "صحيح مُضعَّف", 130, "مَدَّ"],
  ["ءكل", "فعَل يفعُل", "صحيح مهموز الفاء", 134, "أَكَلَ"],
  ["قول", "فعَل يفعُل", "معتل أجوف واوي", 139, "قالَ"],
  ["ضرب", "فعَل يفعِل", "صحيح سالم", 145, "ضَرَبَ"],
  ["رءس", "فعَل يفعِل", "صحيح مهموز العين", 154, "رَأَسَ"],
  ["وصل", "فعَل يفعِل", "معتل مثال واوي", 156, "وَصَلَ"],
  ["رمي", "فعَل يفعِل", "معتل ناقص يائي", 162, "رَمَى"],
  ["فعل", "فعَل يفعَل", "صحيح سالم", 170, "فَعَلَ"],
  ["عضض", "فعَل يفعَل", "صحيح مُضعَّف", 174, "عَضَّ"],
  ["ءله", "فعَل يفعَل", "صحيح مهموز الفاء", 176, "أَلَهَ"],
  ["بيع", "فعَل يفعِل", "معتل أجوف يائي", 159, "باعَ"],
  ["طوي", "فعَل يفعِل", "معتل لفيف مقرون", 167, "طَوَى"],
  ["سءل", "فعَل يفعَل", "صحيح مهموز العين", 177, "سَأَلَ"],
  ["بيت", "فعَل يفعَل", "معتل أجوف يائي", 184, "باتَ"],
  ["سعي", "فعَل يفعَل", "معتل ناقص يائي", 187, "سَعَى"],
  ["كرم", "فعُل يفعُل", "صحيح سالم", 190, "كَرُمَ"],
  ["همم", "فعَل يفعُل", "صحيح مُضعَّف", 193, "هَمَّ"],
  ["ءصل", "فعُل يفعُل", "صحيح مهموز الفاء", 196, "أَصُلَ"],
  ["جرء", "فعُل يفعُل", "صحيح مهموز اللام", 200, "جَرُؤَ"],
  ["يسر", "فعُل يفعُل", "معتل مثال يائي", 202, "يَسُرَ"],
  ["سهو", "فعُل يفعُل", "معتل ناقص واوي", 205, "سَهُوَ"],
  ["علم", "فعِل يفعَل", "صحيح سالم", 207, "عَلِمَ"],
  ["ءلف", "فعِل يفعَل", "صحيح مهموز الفاء", 212, "أَلِفَ"],
  ["بءس", "فعِل يفعَل", "صحيح مهموز العين", 215, "بَئِسَ"],
  ["خطء", "فعِل يفعَل", "صحيح مهموز اللام", 218, "خَطِئَ"],
  ["يقظ", "فعِل يفعَل", "معتل مثال يائي", 221, "يَقِظَ"],
  ["وني", "فعِل يفعَل", "معتل لفيف مفروق", 229, "وَنِيَ"],
  ["وثق", "فعِل يفعِل", "معتل مثال واوي", 235, "وَثِقَ"],
  ["فعل", "أفعل", "صحيح سالم", 272, "أَفْعَلَ"],
  ["وجل", "فعَل يفعُل", "معتل مثال واوي", 137, "وَجَلَ"],
  ["ءثر", "فعَل يفعِل", "صحيح مهموز الفاء", 152, "أَثَرَ"],
  ["بدء", "فعَل يفعَل", "صحيح مهموز اللام", 179, "بَدَأَ"],
  ["حسب", "فعِل يفعِل", "صحيح سالم", 233, "حَسِبَ"],
  ["درء", "تفاعل", "صحيح مهموز اللام", 311, "اِدَّارَأَ"],
  ["تيع", "تفاعل", "معتل أجوف يائي", 315, "اِتّايَعَ"],
  ["فعل", "انفعل", "صحيح سالم", 320, "اِنْفَعَلَ"],
  ["ءطر", "انفعل", "صحيح مهموز الفاء", 324, "اِنْأَطَرَ"],
  ["فعل", "افعلّ", "صحيح سالم", 355, "اِفْعَلَّ"],
  ["فعل", "استفعل", "صحيح سالم", 359, "اِسْتَفْعَلَ"],
  ["فعل", "افعوعل", "صحيح سالم", 373, "اِفْعَوْعَلَ"],
  ["فعل", "افعوّل", "صحيح سالم", 374, "اِفْعَوَّلَ"],
  ["فعل", "افعالّ", "صحيح سالم", 375, "اِفْعالَّ"],
  ["جلذ", "افعوّل", "صحيح سالم", 376, "اِجْلَوَّذَ"],
  ["دهم", "افعالّ", "صحيح سالم", 378, "اِدْهامَّ"],
  ["حوي", "افعوّل", "معتل لفيف مقرون", 383, "اِحْوَوَّى"],
  ["فعلل", "تفعلل", "", 398, "تَفَعْلَلَ"],
  ["فعول", "تفعلل", "", 400, "تَفَعْوَلَ"],
  ["فعيل", "تفعلل", "", 401, "تَفَعْيَلَ"],
  ["فعلل", "افعنلل", "", 410, "اِفْعَنْلَلَ"],
  ["نقض", "افعالّ", "صحيح سالم", 379, "اِنْقاضَّ"],
  ["فعلل", "افعللّ", "", 415, "اِفْعَلَلَّ"],
  ["هوءن", "افعللّ", "", 419, "اِهْوَأَنَّ"],
  ["كتب", "فعَل يفعُل", "صحيح سالم", 127, "كَتَبَ"],
  ["فتح", "فعَل يفعَل", "صحيح سالم", 171, "فَتَحَ"],
  ["نعم", "فعِل يفعِل", "صحيح سالم", 234, "نَعِمَ"],
  ["وري", "فعِل يفعِل", "معتل لفيف مفروق", 238, "وَرِيَ"],
  ["فعل", "تفعّل", "صحيح سالم", 286, "تَفَعَّلَ"],
  ["نصر", "فعَل يفعُل", "صحيح سالم", 128, "نَصَرَ"],
  ["حدث", "فعَل يفعُل", "صحيح سالم", 128, "حَدَثَ"],
  ["وحد", "فعّل", "معتل مثال واوي", 249, "وَحَّدَ"],
  ["يبس", "فعّل", "معتل مثال يائي", 249, "يَبَّسَ"],
  ["نور", "فعّل", "معتل أجوف واوي", 250, "نَوَّرَ"],
  ["بيض", "فعّل", "معتل أجوف يائي", 250, "بَيَّضَ"],
  ["بكي", "فعّل", "معتل ناقص يائي", 253, "بَكَّى"],
  ["مسو", "فعّل", "معتل ناقص واوي", 253, "مَسَّى"],
  ["لوي", "فعّل", "معتل لفيف مقرون", 256, "لَوَّى"],
  ["حيي", "فعّل", "معتل لفيف مقرون مُضعَّف يائي", 256, "حَيَّا"],
  ["قرر", "فعّل", "صحيح مُضعَّف", 244, "قَرَّرَ"],
  ["سبب", "فعّل", "صحيح مُضعَّف", 244, "سَبَّبَ"],
  ["ءمن", "فعّل", "صحيح مهموز الفاء", 246, "أَمَّنَ"],
  ["ءجل", "فعّل", "صحيح مهموز الفاء", 246, "أَجَّلَ"],
  ["رءس", "فعّل", "صحيح مهموز العين", 247, "رَأَّسَ"],
  ["شءم", "فعّل", "صحيح مهموز العين", 247, "شَأَّمَ"],
  ["جزء", "فعّل", "صحيح مهموز اللام", 248, "جَزَّأَ"],
  ["هنء", "فعّل", "صحيح مهموز اللام", 248, "هَنَّأَ"],
  ["ودي", "فعّل", "معتل لفيف مفروق", 255, "وَدَّى"],
  ["وحي", "فعّل", "معتل لفيف مفروق", 255, "وَحَّى"],
  ["جرد", "تفعّل", "صحيح سالم", 287, "تَجَرَّدَ"],
  ["زعم", "تفعّل", "صحيح سالم", 287, "تَزَعَّمَ"],
  ["خفف", "تفعّل", "صحيح مُضعَّف", 289, "تَخَفَّفَ"],
  ["حدد", "تفعّل", "صحيح مُضعَّف", 289, "تَحَدَّدَ"],
  ["ءهل", "تفعّل", "صحيح مهموز الفاء", 290, "تَأَهَّلَ"],
  ["ءبط", "تفعّل", "صحيح مهموز الفاء", 290, "تَأَبَّطَ"],
  ["رءف", "تفعّل", "صحيح مهموز العين", 291, "تَرَأَّفَ"],
  ["ذءب", "تفعّل", "صحيح مهموز العين", 291, "تَذَأَّبَ"],
  ["برء", "تفعّل", "صحيح مهموز اللام", 293, "تَبَرَّأَ"],
  ["نشء", "تفعّل", "صحيح مهموز اللام", 293, "تَنَشَّأَ"],
  ["وجه", "تفعّل", "معتل مثال واوي", 294, "تَوَجَّهَ"],
  ["يتم", "تفعّل", "معتل مثال يائي", 294, "تَيَتَّمَ"],
  ["ودد", "تفعّل", "معتل مثال واوي مُضعَّف", 295, "تَوَدَّدَ"],
  ["يمم", "تفعّل", "معتل مثال يائي مُضعَّف", 295, "تَيَمَّمَ"],
  ["خوف", "تفعّل", "معتل أجوف واوي", 296, "تَخَوَّفَ"],
  ["ميز", "تفعّل", "معتل أجوف يائي", 296, "تَمَيَّزَ"],
  ["ءوه", "تفعّل", "معتل أجوف واوي مهموز الفاء", 297, "تَأَوَّهَ"],
  ["هيء", "تفعّل", "معتل أجوف يائي مهموز اللام", 297, "تَهَيَّأَ"],
  ["طوق", "تفعّل", "معتل أجوف واوي", 298, "اِطَّوَّقَ"],
  ["طير", "تفعّل", "معتل أجوف يائي", 298, "اِطَّيَّرَ"],
  ["دخل", "فعَل يفعُل", "صحيح سالم", 129, "دَخَلَ"],
  ["سقط", "فعَل يفعُل", "صحيح سالم", 129, "سَقَطَ"],
  ["شقق", "فعَل يفعُل", "صحيح مُضعَّف", 131, "شَقَّ"],
  ["ظنن", "فعَل يفعُل", "صحيح مُضعَّف", 131, "ظَنَّ"],
  ["ءخذ", "فعَل يفعُل", "صحيح مهموز الفاء", 135, "أَخَذَ"],
  ["ءمر", "فعَل يفعُل", "صحيح مهموز الفاء", 135, "أَمَرَ"],
  ["عود", "فعَل يفعُل", "معتل أجوف واوي", 140, "عادَ"],
  ["كون", "فعَل يفعُل", "معتل أجوف واوي", 140, "كانَ"],
  ["علو", "فعَل يفعُل", "معتل ناقص واوي", 143, "عَلا"],
  ["غزو", "فعَل يفعُل", "معتل ناقص واوي", 143, "غَزا"],
  ["ثني", "تفعّل", "معتل ناقص يائي", 299, "تَثَنَّى"],
  ["ردي", "تفعّل", "معتل ناقص يائي", 299, "تَرَدَّى"],
  ["ءتي", "تفعّل", "معتل ناقص يائي مهموز الفاء", 300, "تَأَتَّى"],
  ["وخي", "تفعّل", "معتل لفيف مفروق", 300, "تَوَخَّى"],
  ["وعي", "تفعّل", "معتل لفيف مفروق", 301, "تَوَعَّى"],
  ["وفي", "تفعّل", "معتل لفيف مفروق", 301, "تَوَفَّى"],
  ["نوي", "تفعّل", "معتل لفيف مقرون", 302, "تَنَوَّى"],
  ["روي", "تفعّل", "معتل لفيف مقرون", 302, "تَرَوَّى"],
  ["قعد", "تفاعل", "صحيح سالم", 304, "تَقاعَدَ"],
  ["نزل", "تفاعل", "صحيح سالم", 304, "تَنازَلَ"],
  ["ضمم", "فعَل يفعُل", "صحيح مُضعَّف", 132, "ضَمَّ"],
  ["كبب", "فعَل يفعُل", "صحيح مُضعَّف", 132, "كَبَّ"],
  ["ءبب", "فعَل يفعُل", "صحيح مُضعَّف مهموز الفاء", 133, "أَبَّ"],
  ["ءمم", "فعَل يفعُل", "صحيح مُضعَّف مهموز الفاء", 133, "أَمَّ"],
  ["جلس", "فعَل يفعِل", "صحيح سالم", 146, "جَلَسَ"],
  ["رجع", "فعَل يفعِل", "صحيح سالم", 146, "رَجَعَ"],
  ["جزم", "فعَل يفعِل", "صحيح سالم", 147, "جَزَمَ"],
  ["نطق", "فعَل يفعِل", "صحيح سالم", 147, "نَطَقَ"],
  ["خفف", "فعَل يفعِل", "صحيح مُضعَّف", 149, "خَفَّ"],
  ["رنن", "فعَل يفعِل", "صحيح مُضعَّف", 149, "رَنَّ"],
  ["نءت", "فعَل يفعِل", "صحيح مهموز العين", 155, "نَأَتَ"],
  ["نءم", "فعَل يفعِل", "صحيح مهموز العين", 155, "نَأَمَ"],
  ["وءل", "فعَل يفعِل", "معتل مثال واوي مهموز العين", 157, "وَأَلَ"],
  ["وعد", "فعَل يفعِل", "معتل مثال واوي", 157, "وَعَدَ"],
  ["ءتي", "فعَل يفعِل", "معتل ناقص يائي مهموز الفاء", 163, "أَتَى"],
  ["بني", "فعَل يفعِل", "معتل ناقص يائي", 163, "بَنَى"],
  ["ءزي", "فعَل يفعِل", "معتل ناقص يائي مهموز الفاء", 164, "أَزَى"],
  ["قضي", "فعَل يفعِل", "معتل ناقص يائي", 164, "قَضَى"],
  ["شوي", "فعَل يفعِل", "معتل لفيف مقرون", 169, "شَوَى"],
  ["كوي", "فعَل يفعِل", "معتل لفيف مقرون", 169, "كَوَى"],
  ["رهن", "فعَل يفعَل", "صحيح سالم", 172, "رَهَنَ"],
  ["ضغط", "فعَل يفعَل", "صحيح سالم", 172, "ضَغَطَ"],
  ["منع", "فعَل يفعَل", "صحيح سالم", 173, "مَنَعَ"],
  ["ذهب", "فعَل يفعَل", "صحيح سالم", 173, "ذَهَبَ"],
  ["كعع", "فعَل يفعَل", "صحيح مُضعَّف", 175, "كَعَّ"],
  ["رخخ", "فعَل يفعَل", "صحيح مُضعَّف", 175, "رَخَّ"],
  ["درء", "فعَل يفعَل", "صحيح مهموز اللام", 180, "دَرَأَ"],
  ["لجء", "فعَل يفعَل", "صحيح مهموز اللام", 180, "لَجَأَ"],
  ["حسن", "فعُل يفعُل", "صحيح سالم", 191, "حَسُنَ"],
  ["عنف", "فعُل يفعُل", "صحيح سالم", 191, "عَنُفَ"],
  ["صعب", "فعُل يفعُل", "صحيح سالم", 192, "صَعُبَ"],
  ["كبر", "فعُل يفعُل", "صحيح سالم", 192, "كَبُرَ"],
  ["ءدب", "فعُل يفعُل", "صحيح مهموز الفاء", 197, "أَدُبَ"],
  ["ءنث", "فعُل يفعُل", "صحيح مهموز الفاء", 197, "أَنُثَ"],
  ["بطء", "فعُل يفعُل", "صحيح مهموز اللام", 201, "بَطُؤَ"],
  ["نشء", "فعُل يفعُل", "صحيح مهموز اللام", 201, "نَشُؤَ"],
  ["وخش", "فعُل يفعُل", "معتل مثال واوي", 203, "وَخُشَ"],
  ["وسم", "فعُل يفعُل", "معتل مثال واوي", 203, "وَسُمَ"],
  ["فرح", "فعِل يفعَل", "صحيح سالم", 208, "فَرِحَ"],
  ["شبع", "فعِل يفعَل", "صحيح سالم", 208, "شَبِعَ"],
  ["حزن", "فعِل يفعَل", "صحيح سالم", 209, "حَزِنَ"],
  ["ركب", "فعِل يفعَل", "صحيح سالم", 209, "رَكِبَ"],
  ["شرب", "فعِل يفعَل", "صحيح سالم", 210, "شَرِبَ"],
  ["ضحك", "فعِل يفعَل", "صحيح سالم", 210, "ضَحِكَ"],
  ["خصص", "فعِل يفعَل", "صحيح مُضعَّف", 211, "خَصَّ"],
  ["شمم", "فعِل يفعَل", "صحيح مُضعَّف", 211, "شَمَّ"],
  ["ءذن", "فعِل يفعَل", "صحيح مهموز الفاء", 213, "أَذِنَ"],
  ["ءسد", "فعِل يفعَل", "صحيح مهموز الفاء", 213, "أَسِدَ"],
  ["شءو", "فعَل يفعُل", "معتل ناقص واوي مهموز العين", 144, "شَأَى"],
  ["ءثم", "فعِل يفعَل", "صحيح مهموز الفاء", 214, "أَثِمَ"],
  ["ءنس", "فعِل يفعَل", "صحيح مهموز الفاء", 214, "أَنِسَ"],
  ["سءم", "فعِل يفعَل", "صحيح مهموز العين", 216, "سَئِمَ"],
  ["دفء", "فعِل يفعَل", "صحيح مهموز اللام", 219, "دَفِئَ"],
  ["دوي", "فعِل يفعَل", "معتل لفيف مقرون", 231, "دَوِيَ"],
  ["سوي", "فعِل يفعَل", "معتل لفيف مقرون", 231, "سَوِيَ"],
  ["قوي", "فعِل يفعَل", "معتل لفيف مقرون", 232, "قَوِيَ"],
  ["ورم", "فعِل يفعِل", "معتل مثال واوي", 236, "وَرِمَ"],
  ["ورث", "فعِل يفعِل", "معتل مثال واوي", 237, "وَرِثَ"],
  ["يءس", "فعِل يفعِل", "معتل مثال يائي مهموز العين", 237, "يَئِسَ"],
  ["تبع", "فاعل", "صحيح سالم", 258, "تابَعَ"],
  ["غدر", "فاعل", "صحيح سالم", 258, "غادَرَ"],
  ["ضرر", "فاعل", "صحيح مُضعَّف", 259, "ضارَّ"],
  ["شدد", "فاعل", "صحيح مُضعَّف", 259, "شادَّ"],
  ["كفء", "فاعل", "صحيح مهموز اللام", 263, "كافَأَ"],
  ["وجب", "فاعل", "معتل مثال واوي", 264, "وَاجَبَ"],
  ["يسر", "فاعل", "معتل مثال يائي", 264, "يَاسَرَ"],
  ["جوب", "فاعل", "معتل أجوف واوي", 265, "جاوَبَ"],
  ["بيع", "فاعل", "معتل أجوف يائي", 265, "بايَعَ"],
  ["دوي", "فاعل", "معتل لفيف مقرون", 270, "داوَى"],
  ["ثبت", "أفعل", "صحيح سالم", 273, "أَثْبَتَ"],
  ["عرب", "أفعل", "صحيح سالم", 273, "أَعْرَبَ"],
  ["حبب", "أفعل", "صحيح مُضعَّف", 274, "أَحَبَّ"],
  ["رقق", "أفعل", "صحيح مُضعَّف", 274, "أَرَقَّ"],
  ["خطء", "أفعل", "صحيح مهموز اللام", 277, "أَخْطَأَ"],
  ["نبء", "أفعل", "صحيح مهموز اللام", 277, "أَنْبَأَ"],
  ["وحش", "أفعل", "معتل مثال واوي", 278, "أَوْحَشَ"],
  ["يقظ", "أفعل", "معتل مثال يائي", 278, "أَيْقَظَ"],
  ["هوي", "أفعل", "معتل لفيف مقرون", 285, "أَهْوَى"],
  ["كءد", "تفعّل", "صحيح مهموز العين", 292, "تَكَأَّدَ"],
  ["سول", "تفعّل", "معتل أجوف واوي", 292, "تَسَوَّلَ"],
  ["رصص", "تفاعل", "صحيح مُضعَّف", 306, "تَراصَّ"],
  ["مرر", "تفاعل", "صحيح مُضعَّف", 306, "تَمارَّ"],
  ["خطء", "تفاعل", "صحيح مهموز اللام", 310, "تَخاطَأَ"],
  ["رفء", "تفاعل", "صحيح مهموز اللام", 310, "تَرافَأَ"],
  ["ورد", "تفاعل", "معتل مثال واوي", 312, "تَوَارَدَ"],
  ["يمن", "تفاعل", "معتل مثال يائي", 312, "تَيَامَنَ"],
  ["دول", "تفاعل", "معتل أجوف واوي", 313, "تَداوَلَ"],
  ["قيض", "تفاعل", "معتل أجوف يائي", 313, "تَقايَضَ"],
  ["خرط", "انفعل", "صحيح سالم", 321, "اِنْخَرَطَ"],
  ["طلق", "انفعل", "صحيح سالم", 321, "اِنْطَلَقَ"],
  ["فءد", "فعِل يفعَل", "صحيح مهموز العين", 216, "فَئِدَ"],
  ["برء", "فعِل يفعَل", "صحيح مهموز اللام", 219, "بَرِئَ"],
  ["عيي", "فعِل يفعَل", "معتل لفيف مقرون مُضعَّف يائي", 232, "عَيِيَ"],
  ["بطء", "فاعل", "صحيح مهموز اللام", 263, "باطَأَ"],
  ["عيي", "فاعل", "معتل لفيف مقرون مُضعَّف يائي", 270, "عايا"],
  ["حيي", "أفعل", "معتل لفيف مقرون مُضعَّف يائي", 285, "أَحْيا"],
  ["وني", "تفاعل", "معتل لفيف مفروق", 318, "تَوانَى"],
  ["وري", "تفاعل", "معتل لفيف مفروق", 318, "تَوَارَى"],
  ["شقق", "انفعل", "صحيح مُضعَّف", 323, "اِنْشَقَّ"],
  ["دسس", "انفعل", "صحيح مُضعَّف", 323, "اِنْدَسَّ"],
  ["درء", "انفعل", "صحيح مهموز اللام", 325, "اِنْدَرَأَ"],
  ["كفء", "انفعل", "صحيح مهموز اللام", 325, "اِنْكَفَأَ"],
  ["زوي", "انفعل", "معتل لفيف مقرون", 331, "اِنْزَوَى"],
  ["شوي", "انفعل", "معتل لفيف مقرون", 331, "اِنْشَوَى"],
  ["ربط", "افتعل", "صحيح سالم", 333, "اِرْتَبَطَ"],
  ["مزج", "افتعل", "صحيح سالم", 333, "اِمْتَزَجَ"],
  ["زحم", "افتعل", "صحيح سالم", 334, "اِزْدَحَمَ"],
  ["ضلع", "افتعل", "صحيح سالم", 334, "اِضْطَلَعَ"],
  ["ردد", "افتعل", "صحيح مُضعَّف", 338, "اِرْتَدَّ"],
  ["حلل", "افتعل", "صحيح مُضعَّف", 338, "اِحْتَلَّ"],
  ["صفف", "افتعل", "صحيح مُضعَّف", 339, "اِصْطَفَّ"],
  ["زمم", "افتعل", "صحيح مُضعَّف", 339, "اِزْدَمَّ"],
  ["ءمن", "افتعل", "صحيح مهموز الفاء", 341, "اِئْتَمَنَ"],
  ["ءشر", "افتعل", "صحيح مهموز الفاء", 341, "اِئْتَشَرَ"],
  ["بدء", "افتعل", "صحيح مهموز اللام", 345, "اِبْتَدَأَ"],
  ["لجء", "افتعل", "صحيح مهموز اللام", 345, "اِلْتَجَأَ"],
  ["سوي", "افتعل", "معتل لفيف مقرون", 354, "اِسْتَوَى"],
  ["لوي", "افتعل", "معتل لفيف مقرون", 354, "اِلْتَوَى"],
  ["زرق", "افعلّ", "صحيح سالم", 356, "اِزْرَقَّ"],
  ["خرج", "افعلّ", "صحيح سالم", 356, "اِخْرَجَّ"],
  ["سود", "افعلّ", "معتل أجوف واوي", 357, "اِسْوَدَّ"],
  ["بيض", "افعلّ", "معتل أجوف يائي", 357, "اِبْيَضَّ"],
  ["غرب", "استفعل", "صحيح سالم", 360, "اِسْتَغْرَبَ"],
  ["قبل", "استفعل", "صحيح سالم", 360, "اِسْتَقْبَلَ"],
  ["ردد", "استفعل", "صحيح مُضعَّف", 361, "اِسْتَرَدَّ"],
  ["فزز", "استفعل", "صحيح مُضعَّف", 361, "اِسْتَفَزَّ"],
  ["وزر", "استفعل", "معتل مثال واوي", 366, "اِسْتَوْزَرَ"],
  ["يقظ", "استفعل", "معتل مثال يائي", 366, "اِسْتَيْقَظَ"],
  ["ءدي", "استفعل", "معتل ناقص يائي مهموز الفاء", 370, "اِسْتَأْدَى"],
  ["ءني", "استفعل", "معتل ناقص يائي مهموز الفاء", 370, "اِسْتَأْنَى"],
  ["وفي", "استفعل", "معتل لفيف مفروق", 371, "اِسْتَوْفَى"],
  ["ولي", "استفعل", "معتل لفيف مفروق", 371, "اِسْتَوْلَى"],
  ["قوي", "استفعل", "معتل لفيف مقرون", 372, "اِسْتَقْوى"],
  ["حيي", "استفعل", "معتل لفيف مقرون مُضعَّف يائي", 372, "اِسْتَحْيا"],
  ["زلزل", "فعلل", "", 387, "زَلْزَلَ"],
  ["قهقر", "فعلل", "", 387, "قَهْقَرَ"],
  ["سمءل", "فعلل", "", 390, "سَمْأَلَ"],
  ["كرفء", "فعلل", "", 390, "كَرْفَأَ"],
  ["ورور", "فعلل", "", 391, "وَرْوَرَ"],
  ["وشوش", "فعلل", "", 391, "وَشْوَشَ"],
  ["دهور", "فعلل", "", 394, "دَهْوَرَ"],
  ["رهيء", "فعلل", "", 394, "رَهْيَأَ"],
  ["وزوز", "فعلل", "", 395, "وَزْوَزَ"],
  ["وقوق", "فعلل", "", 395, "وَقْوَقَ"],
  ["زحلق", "تفعلل", "", 402, "تَزَحْلَقَ"],
  ["قرفص", "تفعلل", "", 402, "تَقَرْفَصَ"],
  ["سوء", "فعَل يفعُل", "معتل أجوف واوي مهموز اللام", 141, "سَاءَ"],
  ["ءرم", "فعَل يفعِل", "صحيح مهموز الفاء", 153, "أَرَمَ"],
  ["وءد", "فعَل يفعِل", "معتل مثال واوي مهموز العين", 158, "وَأَدَ"],
  ["ضيف", "فعَل يفعِل", "معتل أجوف يائي", 160, "ضافَ"],
  ["لين", "فعَل يفعِل", "معتل أجوف يائي", 161, "لانَ"],
  ["وءي", "فعَل يفعِل", "معتل لفيف مفروق مهموز العين", 166, "وَأَى"],
  ["وعي", "فعَل يفعِل", "معتل لفيف مفروق", 166, "وَعَى"],
  ["ءوي", "فعَل يفعِل", "معتل لفيف مقرون مهموز الفاء", 168, "أَوَى"],
  ["حوي", "فعَل يفعِل", "معتل لفيف مقرون", 168, "حَوَى"],
  ["زءر", "فعَل يفعَل", "صحيح مهموز العين", 178, "زَأَرَ"],
  ["وزع", "فعَل يفعَل", "معتل مثال واوي", 183, "وَزَعَ"],
  ["دوء", "فعَل يفعَل", "معتل أجوف واوي مهموز اللام", 185, "داءَ"],
  ["جود", "فعَل يفعَل", "معتل أجوف واوي", 185, "جادَ"],
  ["حور", "فعَل يفعَل", "معتل أجوف واوي", 186, "حارَ"],
  ["نهي", "فعَل يفعَل", "معتل ناقص يائي", 188, "نَهَى"],
  ["ذلي", "فعَل يفعَل", "معتل ناقص يائي", 189, "ذَلَى"],
  ["حلو", "فعُل يفعُل", "معتل ناقص واوي", 206, "حَلُوَ"],
  ["سرو", "فعُل يفعُل", "معتل ناقص واوي", 206, "سَرُوَ"],
  ["صءب", "فعِل يفعَل", "صحيح مهموز العين", 217, "صَئِبَ"],
  ["وجع", "فعِل يفعَل", "معتل مثال واوي", 222, "وَجِعَ"],
  ["كود", "فعِل يفعَل", "معتل أجوف واوي", 224, "كادَ"],
  ["هوء", "فعِل يفعَل", "معتل أجوف واوي مهموز اللام", 224, "هاءَ"],
  ["ءذي", "فعِل يفعَل", "معتل ناقص يائي مهموز الفاء", 227, "أَذِيَ"],
  ["سخي", "فعِل يفعَل", "معتل ناقص يائي", 227, "سَخِيَ"],
  ["ءسي", "فعِل يفعَل", "معتل ناقص يائي مهموز الفاء", 228, "أَسِيَ"],
  ["عري", "فعِل يفعَل", "معتل ناقص يائي", 228, "عَرِيَ"],
  ["نفذ", "فعّل", "صحيح سالم", 243, "نَفَّذَ"],
  ["فيء", "فعّل", "معتل أجوف يائي مهموز اللام", 252, "فَيَّأَ"],
  ["ءدي", "فعّل", "معتل ناقص يائي مهموز الفاء", 254, "أَدَّى"],
  ["رءو", "فعّل", "معتل ناقص واوي مهموز العين", 254, "رَأَّى"],
  ["جيء", "فاعل", "معتل أجوف يائي مهموز اللام", 266, "جايَأَ"],
  ["وري", "فاعل", "معتل لفيف مفروق", 269, "وارَى"],
  ["قوي", "فاعل", "معتل لفيف مقرون", 271, "قاوَى"],
  ["بءس", "أفعل", "صحيح مهموز العين", 276, "أَبْأَسَ"],
  ["ثور", "أفعل", "معتل أجوف واوي", 279, "أَثارَ"],
  ["رود", "أفعل", "معتل أجوف واوي", 279, "أَرادَ"],
  ["خيل", "أفعل", "معتل أجوف يائي", 280, "أَخْيَلَ"],
  ["سوء", "أفعل", "معتل أجوف واوي مهموز اللام", 281, "أَسَاءَ"],
  ["بدو", "أفعل", "معتل ناقص واوي", 282, "أَبْدَى"],
  ["حصو", "أفعل", "معتل ناقص واوي", 282, "أَحْصَى"],
  ["فءو", "أفعل", "معتل ناقص واوي مهموز العين", 283, "أَفْأَى"],
  ["وصي", "أفعل", "معتل لفيف مفروق", 284, "أَوْصَى"],
  ["لقو", "تفاعل", "معتل ناقص واوي", 316, "تَلاقَى"],
  ["برو", "تفاعل", "معتل ناقص واوي", 316, "تَبارَى"],
  ["دوي", "تفاعل", "معتل لفيف مقرون", 319, "تَدَاوَى"],
  ["زول", "انفعل", "معتل أجوف واوي", 327, "اِنْزالَ"],
  ["قود", "انفعل", "معتل أجوف واوي", 327, "اِنْقادَ"],
  ["برو", "انفعل", "معتل ناقص واوي", 329, "اِنْبَرَى"],
  ["جلو", "انفعل", "معتل ناقص واوي", 329, "اِنْجَلَى"],
  ["صدم", "افتعل", "صحيح سالم", 336, "اِصْطَدَمَ"],
  ["ءجج", "افتعل", "صحيح مُضعَّف مهموز الفاء", 340, "اِئْتَجَّ"],
  ["ءصو", "افتعل", "معتل ناقص واوي مهموز الفاء", 340, "اِئْتَصَى"],
  ["فءل", "افتعل", "صحيح مهموز العين", 343, "اِفْتَأَلَ"],
  ["جوز", "افتعل", "معتل أجوف واوي", 347, "اِجْتازَ"],
  ["رمي", "افتعل", "معتل ناقص يائي", 349, "اِرْتَمَى"],
  ["قضي", "افتعل", "معتل ناقص يائي", 349, "اِقْتَضَى"],
  ["رءو", "افتعل", "معتل ناقص واوي مهموز العين", 351, "اِرْتَأَى"],
  ["روح", "استفعل", "معتل أجوف واوي", 367, "اِسْتَراحَ"],
  ["فود", "استفعل", "معتل أجوف واوي", 367, "اِسْتَفادَ"],
  ["ضوء", "استفعل", "معتل أجوف واوي مهموز اللام", 368, "اِسْتَضَاءَ"],
  ["دعو", "استفعل", "معتل ناقص واوي", 369, "اِسْتَدْعَى"],
  ["عصو", "استفعل", "معتل ناقص واوي", 369, "اِسْتَعْصَى"],
  ["حدب", "افعوعل", "صحيح سالم", 377, "اِحْدَوْدَبَ"],
  ["لءلء", "فعلل", "", 388, "لَأْلَأَ"],
  ["رءبل", "فعلل", "", 389, "رَأْبَلَ"],
  ["دوزن", "فعلل", "", 392, "دَوْزَنَ"],
  ["هروز", "فعلل", "", 393, "هَرْوَزَ"],
  ["دهدو", "فعلل", "", 393, "دَهْدَى"],
  ["رعرع", "تفعلل", "", 403, "تَرَعْرَعَ"],
  ["جفجف", "تفعلل", "", 403, "تَجَفْجَفَ"],
  ["رءبل", "تفعلل", "", 404, "تَرَأْبَلَ"],
  ["ثءلل", "تفعلل", "", 404, "تَثَأْلَلَ"],
  ["دربء", "تفعلل", "", 405, "تَدَرْبَأَ"],
  ["كرثء", "تفعلل", "", 405, "تَكَرْثَأَ"],
  ["وكوك", "تفعلل", "", 406, "تَوَكْوَكَ"],
  ["وطوط", "تفعلل", "", 406, "تَوَطْوَطَ"],
  ["جورب", "تفعلل", "", 407, "تَجَوْرَبَ"],
  ["سرول", "تفعلل", "", 408, "تَسَرْوَلَ"],
  ["حمير", "تفعلل", "", 408, "تَحَمْيَرَ"],
  ["حرجم", "افعنلل", "", 411, "اِحْرَنْجَمَ"],
  ["فرقع", "افعنلل", "", 411, "اِفْرَنْقَعَ"],
  ["سلطء", "افعنلل", "", 412, "اِسْلَنْطَأَ"],
  ["طلفء", "افعنلل", "", 412, "اِطْلَنْفَأَ"],
  ["قشعر", "افعللّ", "", 416, "اِقْشَعَرَّ"],
  ["كفهر", "افعللّ", "", 417, "اِكْفَهَرَّ"],
  ["ضمحل", "افعللّ", "", 417, "اِضْمَحَلَّ"],
  ["زرءم", "افعللّ", "", 418, "اِزْرَأَمَّ"],
  ["طمءن", "افعللّ", "", 418, "اِطْمَأَنَّ"],
  ["يمن", "فعَل يفعُل", "معتل مثال يائي", 138, "يَمَنَ"],
  ["هبيخ", "افعنلل", "", 414, "اِهْبَيَّخَ"],
  ["ءخو", "فعَل يفعُل", "معتل ناقص واوي مهموز الفاء", 144, "أَخا"],
  ["ءيض", "فعَل يفعِل", "معتل أجوف يائي مهموز الفاء", 161, "آضَ"],
  ["وبء", "فعَل يفعَل", "معتل مثال واوي مهموز اللام", 183, "وَبَأَ"],
  ["فءي", "فعَل يفعَل", "معتل ناقص يائي مهموز العين", 189, "فَأَى"],
  ["بدل", "فعّل", "صحيح سالم", 243, "بَدَّلَ"],
  ["ءمم", "فعّل", "صحيح مُضعَّف مهموز الفاء", 245, "أَمَّمَ"],
  ["جنن", "فعّل", "صحيح مُضعَّف", 245, "جَنَّنَ"],
  ["ءيد", "فعّل", "معتل أجوف يائي مهموز الفاء", 251, "أَيَّدَ"],
  ["فرر", "فاعل", "صحيح مُضعَّف", 260, "فارَرَ"],
  ["ءدب", "فاعل", "صحيح مهموز الفاء", 261, "آدَبَ"],
  ["سءل", "فاعل", "صحيح مهموز العين", 262, "سَاءَلَ"],
  ["لءم", "فاعل", "صحيح مهموز العين", 262, "لَاءَمَ"],
  ["ءوي", "فاعل", "معتل لفيف مقرون مهموز الفاء", 271, "آوَى"],
  ["ءجر", "أفعل", "صحيح مهموز الفاء", 275, "آجَرَ"],
  ["ءذن", "أفعل", "صحيح مهموز الفاء", 275, "آذَنَ"],
  ["ثوب", "أفعل", "معتل أجوف واوي", 280, "أَثْوَبَ"],
  ["عثث", "تفاعل", "صحيح مُضعَّف", 307, "تَعاثَثَ"],
  ["غضض", "تفاعل", "صحيح مُضعَّف", 307, "تَغاضَضَ"],
  ["ءمر", "تفاعل", "صحيح مهموز الفاء", 308, "تَآمَرَ"],
  ["ءلف", "تفاعل", "صحيح مهموز الفاء", 308, "تَآلَفَ"],
  ["بوء", "تفاعل", "معتل أجوف واوي مهموز اللام", 314, "تَباوَأَ"],
  ["مدح", "انفعل", "صحيح سالم", 322, "اِمَّدَحَ"],
  ["نمس", "انفعل", "صحيح سالم", 322, "اِنَّمَسَ"],
  ["سيء", "انفعل", "معتل أجوف يائي مهموز اللام", 328, "اِنْسَيَأَ"],
  ["طلب", "افتعل", "صحيح سالم", 335, "اِطَّلَبَ"],
  ["ذكر", "افتعل", "صحيح سالم", 336, "اِذَّكَرَ"],
  ["ءحد", "افتعل", "صحيح مهموز الفاء", 342, "اِتَّحَدَ"],
  ["ءزر", "افتعل", "صحيح مهموز الفاء", 342, "اِتَّزَرَ"],
  ["تءم", "افتعل", "صحيح مهموز العين", 344, "اِتَّأَمَ"],
  ["وزن", "افتعل", "معتل مثال واوي", 346, "اِتَّزَنَ"],
  ["وصف", "افتعل", "معتل مثال واوي", 346, "اِتَّصَفَ"],
  ["عول", "افتعل", "معتل أجوف واوي", 347, "اِعْتَوَلَ"],
  ["ءسي", "افتعل", "معتل ناقص يائي مهموز الفاء", 351, "اِئْتَسَى"],
  ["وقو", "افتعل", "معتل لفيف مفروق", 352, "اِتَّقَى"],
  ["جوب", "استفعل", "معتل أجوف واوي", 368, "اِسْتَجْوَبَ"],
  ["قلد", "افعوّل", "صحيح سالم", 377, "اِقْلَوَّدَ"],
  ["ورق", "افعالّ", "معتل مثال واوي", 380, "اِيراقَّ"],
  ["ورد", "افعالّ", "معتل مثال واوي", 380, "اِيرادَّ"],
  ["حول", "افعالّ", "معتل أجوف واوي", 381, "اِحْوالَّ"],
  ["زين", "افعالّ", "معتل أجوف يائي", 381, "اِزْيانَّ"],
  ["شرو", "افعوعل", "معتل ناقص واوي", 382, "اِشْرَوْرَى"],
  ["سيطر", "فعلل", "", 392, "سَيْطَرَ"],
  ["فيلق", "تفعلل", "", 407, "تَفَيْلَقَ"],
  ["وحوح", "تفعلل", "", 409, "تَوَحْوَحَ"],
  ["ولول", "تفعلل", "", 409, "تَوَلْوَلَ"],
  ["ءول", "فعَل يفعُل", "معتل أجوف واوي مهموز الفاء", 141, "آلَ"],
  ["ءبت", "فعَل يفعِل", "صحيح مهموز الفاء", 153, "أَبَتَ"],
  ["يتم", "فعَل يفعِل", "معتل مثال يائي", 158, "يَتَمَ"],
  ["جيء", "فعَل يفعِل", "معتل أجوف يائي مهموز اللام", 160, "جاءَ"],
  ["مءن", "فعَل يفعَل", "صحيح مهموز العين", 178, "مَأَنَ"],
  ["سول", "فعَل يفعَل", "معتل أجوف واوي", 186, "سالَ"],
  ["عشش", "فعَل يفعُل", "صحيح مُضعَّف", 194, "عَشَّ"],
  ["فكك", "فعَل يفعُل", "صحيح مُضعَّف", 194, "فَكَّ"],
  ["شءز", "فعِل يفعَل", "صحيح مهموز العين", 217, "شَئِزَ"],
  ["وطء", "فعِل يفعَل", "معتل مثال واوي مهموز اللام", 222, "وَطِئَ"],
  ["ءول", "فعّل", "معتل أجوف واوي مهموز الفاء", 251, "أَوَّلَ"],
  ["ضوء", "فعّل", "معتل أجوف واوي مهموز اللام", 252, "ضَوَّأَ"],
  ["علل", "فاعل", "صحيح مُضعَّف", 260, "عالَلَ"],
  ["نوء", "فاعل", "معتل أجوف واوي مهموز اللام", 266, "ناوَأَ"],
  ["وخي", "فاعل", "معتل لفيف مفروق", 269, "واخَى"],
  ["ثءر", "أفعل", "صحيح مهموز العين", 276, "أَثْأَرَ"],
  ["نيء", "أفعل", "معتل أجوف يائي مهموز اللام", 281, "أَنْيَأَ"],
  ["رءو", "أفعل", "معتل ناقص واوي مهموز العين", 283, "أَرَى"],
  ["ودي", "أفعل", "معتل لفيف مفروق", 284, "أَوْدَى"],
  ["ءدي", "تفاعل", "معتل ناقص يائي مهموز الفاء", 314, "تَآدَى"],
  ["رءو", "تفاعل", "معتل ناقص واوي مهموز العين", 317, "تَراءَى"],
  ["شءو", "تفاعل", "معتل ناقص واوي مهموز العين", 317, "تَشاءَى"],
  ["ويل", "تفاعل", "معتل لفيف مقرون", 319, "تَوَايَلَ"],
  ["ءيد", "انفعل", "معتل أجوف يائي مهموز الفاء", 328, "اِنْآدَ"],
  ["رءس", "افتعل", "صحيح مهموز العين", 343, "اِرْتَأَسَ"],
  ["ظءر", "افتعل", "صحيح مهموز العين", 344, "اِظَّأَرَ"],
  ["دعو", "افتعل", "معتل ناقص واوي", 350, "اِدَّعَى"],
  ["طلو", "افتعل", "معتل ناقص واوي", 350, "اِطَّلَى"],
  ["ودي", "افتعل", "معتل لفيف مفروق", 352, "اِتَّدَى"],
  ["عمي", "افعالّ", "معتل ناقص يائي", 382, "اِعْمايَّ"],
  ["زءزء", "فعلل", "", 388, "زَأْزَأَ"],
  ["ثءلل", "فعلل", "", 389, "ثَأْلَلَ"],
  ["زلحف", "افعللّ", "", 416, "اِزْلَحَفَّ"],
  ["رءي", "فعَل يفعَل", "معتل ناقص يائي مهموز العين", 188, "رَأَى"],
  ["يبس", "فعِل يفعِل", "معتل مثال يائي", 236, "يَبِسَ"],
  ["وضع", "فعَل يفعَل", "معتل مثال واوي", 182, "وَضَعَ"],
  ["صحح", "فعَل يفعِل", "صحيح مُضعَّف", 150, "صَحَّ"],
  ["تمم", "فعَل يفعِل", "صحيح مُضعَّف", 150, "تَمَّ"],
  ["ءثث", "فعَل يفعِل", "صحيح مُضعَّف مهموز الفاء", 151, "أَثَّ"],
  ["ءنن", "فعَل يفعِل", "صحيح مُضعَّف مهموز الفاء", 151, "أَنَّ"],
  ["ملء", "فعَل يفعَل", "صحيح مهموز اللام", 181, "مَلَأَ"],
  ["هزء", "فعَل يفعَل", "صحيح مهموز اللام", 181, "هَزَأَ"],
  ["شرر", "فعَل يفعُل", "صحيح مُضعَّف", 195, "شَرَّ"],
  ["لبب", "فعَل يفعُل", "صحيح مُضعَّف", 195, "لَبَّ"],
  ["ظمء", "فعِل يفعَل", "صحيح مهموز اللام", 220, "ظَمِئَ"],
  ["فتء", "فعِل يفعَل", "صحيح مهموز اللام", 220, "فَتِئَ"],
  ["شيء", "فعِل يفعَل", "معتل أجوف يائي مهموز اللام", 225, "شاءَ"],
  ["ندو", "فاعل", "معتل ناقص واوي", 267, "نادَى"],
  ["درو", "فاعل", "معتل ناقص واوي", 267, "دارَى"],
  ["ءذي", "فاعل", "معتل ناقص يائي مهموز الفاء", 268, "آذَى"],
  ["شءو", "فاعل", "معتل ناقص واوي مهموز العين", 268, "شاءَى"],
  ["رءد", "تفاعل", "صحيح مهموز العين", 309, "تَراءَدَ"],
  ["فءل", "تفاعل", "صحيح مهموز العين", 309, "تَفاءَلَ"],
  ["حنو", "انفعل", "معتل ناقص واوي", 330, "اِنْحَنَى"],
  ["فءي", "انفعل", "معتل ناقص يائي مهموز العين", 330, "اِنْفَأَى"],
  ["صود", "افتعل", "معتل أجوف واوي", 348, "اِصْطادَ"],
  ["وءي", "افتعل", "معتل لفيف مفروق مهموز العين", 353, "اِتَّأَى"],
  ["وشي", "افتعل", "معتل لفيف مفروق", 353, "اِيْتَشَى"],
  ["ءبب", "استفعل", "صحيح مُضعَّف مهموز الفاء", 362, "اِسْتَأَبَّ"],
  ["ءمم", "استفعل", "صحيح مُضعَّف مهموز الفاء", 362, "اِسْتَأَمَّ"],
  ["ءنف", "استفعل", "صحيح مهموز الفاء", 363, "اِسْتَأْنَفَ"],
  ["ءصل", "استفعل", "صحيح مهموز الفاء", 363, "اِسْتَأْصَلَ"],
  ["شءم", "استفعل", "صحيح مهموز العين", 364, "اِسْتَشْأَمَ"],
  ["ثءر", "استفعل", "صحيح مهموز العين", 364, "اِسْتَثْأَرَ"],
  ["قرء", "استفعل", "صحيح مهموز اللام", 365, "اِسْتَقْرَأَ"],
  ["نبء", "استفعل", "صحيح مهموز اللام", 365, "اِسْتَنْبَأَ"],
  ["ءوب", "فعِل يفعَل", "معتل أجوف واوي مهموز الفاء", 225, "أَوِبَ"],
  ["زوج", "افتعل", "معتل أجوف واوي", 348, "اِزْدَوَجَ"],
];
